import window from 'window';
import $ from 'rgs-jquery';
import api from 'google-tag-manager';

$(() => {
	const pusher = api.pusher().event('addEvents');

	$(window.document).on(
		'click.google-tag-manager.data-api',
		'[data-gtm-category][data-gtm-action]',
		 (e) => {
			const $target = $(e.target);

			const cat = $target.attr('data-gtm-category');
			const act = $target.attr('data-gtm-action');
				
			pusher
				.category(cat)
				.action(act)
				.push();
		}
	);
});
